export const arrowLeft = 'arrow-left';
export const arrowRight = 'arrow-right';
export const swipeLeft = 'swipe-left';
export const swipeRight = 'swipe-right';
export type ArrowLeft = typeof arrowLeft;
export type ArrowRight = typeof arrowRight;
export type SwipeLeft = typeof swipeLeft;
export type SwipeRight = typeof swipeRight;
export type SwipeDirection = SwipeLeft | SwipeRight | null;
export type ActionType =
    | 'panel-item'
    | ArrowLeft
    | ArrowRight
    | SwipeLeft
    | SwipeRight;
export type LoadType = 'manual' | 'automatic';
export type SliderTrackingEventProps = Readonly<{
    actionName?: ActionType;
    headingLabel: string;
    index: number;
    isRotating?: boolean;
    itemCount: number;
    itemPosition: number;
    loadType?: LoadType;
}>;
